module.exports = __webpack_public_path__ + "img/icon-payment-cards - Copy.f374b8b0.png";